

    
<template>
  <v-dialog v-model="showModal" max-width="500px">
    <v-card >
      <v-card-title> {{ title }} </v-card-title>
      <v-card-text>
        <p>{{ description }}</p>
        <v-select
          :items="items"
          label="Descrizione"
          item-value="value"
          item-text="description"
          v-model="selectedItem"
          v-bind:value="selectedValue"
        >
        </v-select>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-bind:key="btn"
          color="primary"
          v-on:click="btn_Click(btn)"
          v-for="btn in buttons"
        >
          {{ btn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


 <style lang="">
</style> 
<script>
export default {
  data: () => ({
    items: [],
    showModal: false,
    selectedItem: { },
    buttons: [],
    title: "",
    description: "",
    selectedValue:null,
    callback: function () {},
  }), 
  watch:{

  },
  methods: {
    btn_Click(value) {
      this.showModal = false; 
        this.callback(value, this.selectedItem); 
    },
    
    Show(title, description, buttons, items, callback) {
      this.dialogResult = "";
      this.title = title;
      this.items = items;
      this.description = description;
      this.buttons = buttons;
      this.callback = callback;
      this.showModal = true; 
    },
    
    ShowEdit(title, description, buttons, items,selectedValue, callback) {
      this.dialogResult = "";
      this.title = title;
      this.items = items;
      this.description = description;
      this.buttons = buttons;
      this.callback = callback;
      this.showModal = true;
      console.debug("selected",selectedValue) 
        this.selectedItem=selectedValue; 
    },
  },
};
</script>

